import { render, staticRenderFns } from "./weChat-video-number.vue?vue&type=template&id=70b23400&scoped=true&"
import script from "./weChat-video-number.vue?vue&type=script&lang=js&"
export * from "./weChat-video-number.vue?vue&type=script&lang=js&"
import style0 from "./weChat-video-number.vue?vue&type=style&index=0&id=70b23400&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b23400",
  null
  
)

export default component.exports